<script setup lang="ts">
import { NxtInput, NxtPhoneNumberInput } from '@future-harry/nxt-styles';
import MediaSelector from '@/core/components/form-elements/MediaSelector.vue';
import DraggableFormList from '@/core/components/form-elements/DraggableFormList.vue';
import { Contact } from '@/modules/content-blocks/interfaces/contacts-block.interface';
import { createDefaultContact } from '@/modules/content-blocks/helpers/contacts-block.helper';

const model = defineModel<any>();

const props = defineProps<{
   errors: Record<string, string>;
}>();

const addContact = (data: { contacts: Contact[] }) => {
   data.contacts = [...data.contacts, createDefaultContact()];
};

const removeContact = (data: { contacts: Contact[] }, id: string) => {
   const idx = data.contacts.findIndex((c: Contact) => c.id === id);
   if (idx !== -1) {
      data.contacts.splice(idx, 1);
   }
};
</script>

<template>
   <DraggableFormList
      v-model="model.contacts"
      :add-button-label="$t('live-editor.content-blocks.contacts.add-contact')"
      @add="addContact(model as { contacts: Contact[] })"
      @remove="removeContact(model as { contacts: Contact[] }, $event)"
   >
      <template #title="{ item: contact }">
         <h4>{{ contact.name || $t('live-editor.content-blocks.contacts.name') }}</h4>
      </template>
      <template #fields="{ item: contact, index }">
         <MediaSelector v-model="contact.image.url" />
         <NxtInput
            :label="$t('live-editor.content-blocks.contacts.name')"
            :name="`contacts[${index}].name`"
            v-model="contact.name"
            :errors="errors"
         />
         <NxtPhoneNumberInput
            :label="$t('live-editor.content-blocks.contacts.phone')"
            :name="`contacts[${index}].phone`"
            v-model="contact.phone"
         />
         <NxtInput
            type="email"
            :label="$t('live-editor.content-blocks.contacts.email')"
            :name="`contacts[${index}].email`"
            v-model="contact.email"
            :errors="errors"
         />
      </template>
   </DraggableFormList>
</template>
